<template>
  <section class="section workflow-section" id="workflow">
    <div class="section-copy">
      <h2 class="section-title">{{ $t('home.workflow.title') }}</h2>
      <p>{{ $t('home.workflow.subtitle') }}</p>
    </div>

    <ol class="workflow-grid">
      <li v-for="(step, index) in steps" :key="step.id" class="workflow-step">
        <div class="workflow-shot">
          <img :src="step.image" :alt="step.alt" loading="lazy">
        </div>
        <span class="workflow-index">{{ String(index + 1).padStart(2, '0') }}</span>
        <h3>{{ step.title }}</h3>
        <p>{{ step.description }}</p>
      </li>
    </ol>
  </section>
</template>

<script>
import libraryZh from '@/assets/home/step-library-zh.webp';
import libraryEn from '@/assets/home/step-library-en.webp';
import repeatZh from '@/assets/home/step-repeat-zh.webp';
import repeatEn from '@/assets/home/step-repeat-en.webp';
import scoreZh from '@/assets/home/step-score-zh.webp';
import scoreEn from '@/assets/home/step-score-en.webp';

const STEP_IMAGES = {
  library: { zh: libraryZh, en: libraryEn },
  repeat: { zh: repeatZh, en: repeatEn },
  score: { zh: scoreZh, en: scoreEn }
};

export default {
  name: 'HomeWorkflowSection',
  computed: {
    steps() {
      const locale = this.$i18n.locale === 'en' ? 'en' : 'zh';
      const copy = this.$tm('home.workflow.steps');
      return Object.keys(STEP_IMAGES).map((id) => ({
        ...copy[id],
        id,
        image: STEP_IMAGES[id][locale]
      }));
    }
  }
};
</script>

<style scoped>
.workflow-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space-6);
  width: min(1180px, 100%);
  margin: 0;
  padding: 0;
  list-style: none;
}

.workflow-step {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.workflow-shot {
  aspect-ratio: 3 / 2;
  overflow: hidden;
  margin-bottom: var(--space-5);
  border: 1px solid var(--border-subtle);
  border-radius: 12px;
  background: var(--surface-subtle);
}

.workflow-shot img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.workflow-index {
  color: var(--ink-tertiary);
  font-family: var(--font-family-data);
  font-size: var(--font-size-sm);
  font-weight: 500;
}

.workflow-step h3 {
  margin: var(--space-2) 0 0;
  color: var(--ink-primary);
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1.35;
}

.workflow-step p {
  margin: var(--space-2) 0 0;
  color: var(--ink-secondary);
  font-size: 0.9375rem;
  line-height: 1.65;
}

@media (max-width: 1024px) {
  .workflow-grid {
    grid-template-columns: 1fr;
    max-width: 560px;
  }
}
</style>
